import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import { fileSystemStore } from '@/store';

import AppEntry from '@/pages/AppEntry.vue';
import * as Setup from '@/pages/setup';
import * as Music from '@/pages/music';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: AppEntry
  },
  { path: '/setup', name: 'Setup', ...Setup },
  { path: '/music', name: 'Music', ...Music }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/' && !fileSystemStore.getState().rootHandle) {
    next({
      path: '/',
      query: {
        r: to.fullPath
      }
    });
  } else {
    next();
  }
});

export default router;
